import React from 'react'

import BuyGameSection from '../elements/store/store-buy-section'
import Newsletter from '../elements/newsletter'
import Section from './section'

const DynamicSections = ({ globalData, pageContext, globalContext, data, styling, newsletterList, newsletter: NewsletterExtension, newsletterForm: NewsletterForm, buygame: BuyGameExtension, banner: NotificationBanner }) => {
  const newsletterData = data.newsletterData ? data.newsletterData : null
  const ageGateData = data.ageGateData ? data.ageGateData : null
  const gameData = data.gameData ? data.gameData : null
  const bannerData = data.bannerData ? data.bannerData : null
  const stringsData = data.stringsData ? data.stringsData : null
  const dataLayer = globalContext.dataLayer ? globalContext.dataLayer : null

  // Per-page section disabling
  const disableBuyGameSection = (data.disableBuyGameSection || gameData === null) ? true : false
  const disableNewsletterSignup = (data.disableNewsletterSignup || newsletterData === null) ? true : false
  const disableNotificationBanner = (data.disableNotificationBanner || bannerData === null) ? true : false

  // Custom styles
  const buyGameSectionStyles = styling && styling.buyGameStyles && styling.buyGameStyles.Section ? styling.buyGameStyles.Section : undefined
  const newsletterSectionStyles = styling && styling.newsletterStyles && styling.newsletterStyles.Section ? styling.newsletterStyles.Section : undefined
  const newsletterFormStyles = styling && styling.newsletterStyles && styling.newsletterStyles.Form ? styling.newsletterStyles.Form : undefined

  return (
    <>
      {!disableNotificationBanner && (
        <NotificationBanner data={bannerData} />
      )}
      {!disableBuyGameSection && (
        <Section
          name='buy-game'
          styling={buyGameSectionStyles}
          content={BuyGameExtension}
        >
          <BuyGameSection
            pageContext={globalContext}
            data={gameData}
            styling={buyGameSectionStyles}
            dataLayer={dataLayer !== null && dataLayer.buyGame ? dataLayer.buyGame : null}
          />
        </Section>
      )}
      {!disableNewsletterSignup && (
        <Section
          name='newsletter'
          styling={newsletterSectionStyles}
          content={NewsletterExtension}
        >
          {/* Use Project's Newsletter Component of the Theme's Default */}
          {NewsletterForm ? (
            <NewsletterForm
              globalData={globalData}
              pageContext={pageContext}
            />
          ) : (
            <Newsletter
              pageContext={globalContext}
              data={{ newsletterData, ageGateData }}
              strings={stringsData}
              styling={newsletterFormStyles}
              dataLayer={dataLayer?.newsletter || null}
              leadTracking={dataLayer?.queryString || null}
              list={newsletterList}
              devMode={process.env.GATSBY_ENV === 'dev' && !process.env.GATSBY_DISABLE_DEVTOOLS}
            />
          )}
        </Section>
      )}
    </>
  )
}

export default DynamicSections
